/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { Constants } from '../constants';
import { Log } from '../logging/Log';

export class RecoveryMechanism {
    private static TAG: string = 'RecoveryMechanism';

    private static serviceInRecoverySet: Set<string> = new Set();

    static async callServiceWithRecovery<ResponseType>(
        serviceFunction: Function,
        serviceFunctionParameters: Array<any>,
        recoveryDelayTime?: number,
    ): Promise<ResponseType> {
        const recoveryDelay = recoveryDelayTime || Constants.DEFAULT_RECOVERY_DELAY;
        if (!this.serviceInRecoverySet.has(`${serviceFunction}`)) {
            let attempts = 0;
            return new Promise((resolve) => {
                const recoverService = () => {
                    this.serviceInRecoverySet.add(`${serviceFunction}`);
                    return serviceFunction(...serviceFunctionParameters)
                        .then((res) => {
                            this.serviceInRecoverySet.delete(`${serviceFunction}`);
                            return resolve(res);
                        })
                        .catch((error: any) => {
                            let delay = recoveryDelay * attempts;
                            if (error?.response) {
                                const { headers } = error.response;
                                const lowerCaseHeaders = {};
                                Object.keys(headers || {}).forEach((header) => {
                                    lowerCaseHeaders[header.toLowerCase()] = headers[header];
                                });
                                const retryAfterDelay = lowerCaseHeaders['retry-after'];
                                if (retryAfterDelay) {
                                    Diagnostics.debug(
                                        this.TAG,
                                        `using delay from retry-after header: ${retryAfterDelay}`,
                                    );
                                    Log.d(
                                        this.TAG,
                                        `using delay from retry-after header: ${retryAfterDelay}`,
                                    );
                                    // seconds to mili seconds
                                    delay = retryAfterDelay * 1000;
                                }
                            }
                            Diagnostics.debug(
                                this.TAG,
                                `attempt: ${attempts} delay: ${delay}`,
                                error,
                            );
                            Log.d(this.TAG, `attempt: ${attempts} delay: ${delay}`, error);
                            setTimeout(() => {
                                attempts += 1;
                                return recoverService();
                            }, delay);
                        });
                };
                return setTimeout(() => {
                    attempts += 1;
                    return recoverService();
                }, recoveryDelay);
            });
        }
        throw new Error(`${serviceFunction} already in recovery`);
    }
}
